export default "__VITE_ASSET__CjMGrhmE__"